module.exports = __webpack_public_path__ + "img/temp-boringavatar.c58069f6.png";